<template>
  <div>
    <VueChatBot
      class="skip-capture"
      :messages="data"
      :options="botOptions"
      @msg-send="messageSendHandler"
      :bot-typing="botTyping"
      @open="openChatBot"
      @destroy="closeChatBot"
    />
    <div v-if="ifSupportNeed">
      <div
        class="row"
        style="position: fixed; right: 25px; bottom: 100px; text-align: end; z-index: 10"
      >
        <div class="col-12 py-0">
          <v-btn
            @click="showChatBot"
            style="text-transform: capitalize"
            elevation="0"
            outlined
            class="rounded-pill blue--text font-weight-bold bg-white"
            >AI Assistant</v-btn
          >
        </div>
        <div class="col-12">
          <v-btn
            @click="openSupport"
            style="text-transform: capitalize"
            elevation="0"
            outlined
            class="rounded-pill blue--text font-weight-bold bg-white"
            >Success Center</v-btn
          >
        </div>
      </div>
    </div>
    <template v-else>
      <div class="qkb-bot-custom-buttons d-flex flex-row" v-if="open">
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'prompt' }"
              @click="setType('prompt')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-help</v-icon>
            </v-btn>
          </template>
          <span>Ask a Question</span>
        </v-tooltip>
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'generateExtension' }"
              @click="setType('generateExtension')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-xml</v-icon>
            </v-btn>
          </template>
          <span>Generate Extension</span>
        </v-tooltip>
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'generateVariable' }"
              @click="setType('generateVariable')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-variable</v-icon>
            </v-btn>
          </template>
          <span>Generate Variable</span>
        </v-tooltip>
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'generateCode' }"
              @click="setType('generateCode')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-code-tags</v-icon>
            </v-btn>
          </template>
          <span>Generate Code</span>
        </v-tooltip>
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'generateDsl' }"
              @click="setType('generateDsl')"
              v-bind="attrs"
              v-on="on"
            >
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7.4 16.6L2.8 12L7.4 7.4L6 6L0 12L6 18L7.4 16.6ZM16.6 16.6L21.2 12L16.6 7.4L18 6L24 12L18 18L16.6 16.6Z"
                  fill="#fff"
                />
                <rect x="8.03125" y="9.4375" width="4.3125" height="2" rx="1" fill="#fff" />
                <rect x="11.6562" y="12.5625" width="4.3125" height="2" rx="1" fill="#fff" />
                <rect x="13.9688" y="9.4375" width="2" height="2" rx="1" fill="#fff" />
                <rect x="8.03125" y="12.5625" width="2" height="2" rx="1" fill="#fff" />
              </svg>
            </v-btn>
          </template>
          <span>Element Miner</span>
        </v-tooltip>
        <v-tooltip top close-delay="1000" content-class="pointerEvents">
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              dark
              icon
              :class="{ active: type === 'generateDataFomExample' }"
              @click="setType('generateDataFomExample')"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-chart-bar</v-icon>
            </v-btn>
          </template>
          <span>Generate Data From Example</span>
        </v-tooltip>
      </div>
    </template>
  </div>
</template>

<script>
import { VueChatBot } from "vue-chat-bot";
import { mapState } from "vuex";

export default {
  name: "GlobalChatBot",
  components: {
    VueChatBot,
  },
  data() {
    return {
      openFromExternal: false,
      ifSupportNeed: false,
      open: false,
      type: "prompt",
      mode: "",
      botTyping: false,
      data: [
        {
          agent: "bot", // Required. 'bot' or 'user'
          type: "html", // Required. Bubble message component type: 'text' / 'button'
          text: "<p style='display: flex; align-items: center;'><img src='/views/images/logo/logo-small.svg' alt='Functionize Logo' style='height: 30px;'> <span style='margin-left: 10px;'>Hey there! How can I help?</span></p>", // Required. The message
          disableInput: false, // Disable message input or not
        },
      ],
      botOptions: {
        botTitle: "AI Assistant",
        botAvatarImg: "",
        colorScheme: "#6D6798",
        msgBubbleBgUser: "#7D5697",
        msgBubbleColorUser: "#FFFFFF",
        msgBubbleBgBot: "#F6F7FF",
        msgBubbleColorBot: "#4A3D67",
      },
      endpoints: {
        prompt: "/uiapi/detail/chatprompt",
        generateExtension: "/uiapi/detail/chatgenerateextension",
        generateVariable: "/uiapi/detail/chatgeneratevariable",
        generateCode: "/uiapi/detail/chatgeneratecode",
        generateDsl: "/uiapi/detail/chatgeneratedsl",
        generateDataFomExample: "/uiapi/detail/chatgeneratedatafomexample",
      },
    };
  },
  computed: {
    ...mapState({
      window: (state) => state.window,
    }),
  },
  created() {
    this.$root.$refs["GlobalChatBot"] = this;
  },
  methods: {
    openSupport() {
      this.botClose();
      window.ChurnZero.push(["open"]);
    },
    showChatBot() {
      this.ifSupportNeed = false;
      document.querySelector(".qkb-board").style.display = "flex";
      this.open = true;
    },
    openChatBot() {
      if (this.window.churnzero_app_key && window.userHaveSuccessCenter && !this.openFromExternal) {
        this.ifSupportNeed = true;
        const interval = setInterval(() => {
          if (document.querySelector(".qkb-board")) {
            document.querySelector(".qkb-board").style.display = "none";
            clearInterval(interval);
          }
        }, 10);
        return;
      }
      this.ifSupportNeed = false;
      this.open = true;
    },
    closeChatBot() {
      this.ifSupportNeed = false;
      this.open = false;
    },
    botOpen() {
      if (!document.querySelector(".qkb-board")) {
        this.openFromExternal = true;
        setTimeout(() => {
          this.openFromExternal = false;
        }, 1000);
        document.querySelector(".qkb-bubble-btn").click();
      }
    },
    botClose() {
      if (document.querySelector(".qkb-board")) {
        document.querySelector(".qkb-bubble-btn").click();
      }
    },
    setType(type, mode) {
      this.type = type;
      this.mode = mode;
    },
    messageSendHandler(data) {
      this.data.push({
        agent: "user",
        type: "text",
        text: data.text,
      });
      this.botTyping = true;
      this.J_POST(this.endpoints[this.type], {
        message: `${data.text} ${this.mode && this.mode != "application/ld+json" ? this.mode : ""}`,
        CSRFToken: this.window.CSRFToken,
      })
        .then((response) => {
          if (response && response.response) {
            let localResponse = response.response;
            this.data.push({
              agent: "bot",
              type: "html",
              text: localResponse,
            });
            if (
              window.activeEditor &&
              (this.type === "generateCode" ||
                this.type === "generateVariable" ||
                this.type === "generateExtension")
            ) {
              if (this.type === "generateVariable") {
                localResponse = localResponse.slice(
                  localResponse.indexOf("{{") + 2,
                  localResponse.lastIndexOf("}}")
                );
              } else if (this.type === "generateCode" || this.type === "generateExtension") {
                let regex = /```(text)?\/?(javascript|python|go|java|xml|html|plain)?\n?/g;
                let tempResponse = localResponse.split(regex);
                if (
                  ["javascript", "python", "go", "java", "xml", "html", "plain"].includes(
                    tempResponse[2]
                  )
                ) {
                  localResponse = tempResponse[3];
                } else {
                  if (tempResponse[2]) {
                    localResponse = tempResponse[2];
                  } else {
                    localResponse = localResponse.slice(
                      localResponse.indexOf("```") + 3,
                      localResponse.lastIndexOf("```")
                    );
                  }
                }
              }
              window.activeEditor.setValue(localResponse);
              window.activeEditor = null;
              this.mode = "";
              //this.botClose();
            }
          } else {
            this.data.push({
              agent: "bot",
              type: "html",
              text: "I got an empty answer",
            });
          }
        })
        .finally(() => {
          this.botTyping = false;
        })
        .catch(() => {
          this.botTyping = false;
          this.data.push({
            agent: "bot",
            type: "html",
            text: "Something went wrong",
          });
        });
    },
  },
};
</script>

<style lang="scss">
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.qkb-bot-custom-buttons {
  position: fixed;
  z-index: 1000;
  bottom: 2.2rem;
  right: 7rem;
  animation: fadeIn 0.5s;
}

.qkb-bot-custom-buttons button {
  color: #ffffff;
  background: #6d6798;
  margin-right: 10px;
}

.qkb-bot-custom-buttons button.active {
  background: #00b2ff;
}

.qkb-msg-bubble.qkb-msg-bubble--bot .qkb-msg-bubble-component {
  word-wrap: break-word;
  max-width: 320px;
}

.qkb-msg-bubble--bot .qkb-msg-bubble-component__text {
  border-radius: 20px 20px 20px 0px;
}

.qkb-msg-bubble--user .qkb-msg-bubble-component__text {
  border-radius: 20px 20px 0px 20px;
  word-break: break-all;
}

.qkb-msg-bubble-component__text a {
  background: #ffffff;
  box-shadow: 0px 2px 5px rgba(116, 99, 154, 0.5);
  border-radius: 10px;
  padding: 1px 8px;
  overflow: hidden;
  display: block;
  height: 23px;
  margin: 8px 0;
}

.qkb-msg-bubble-component__text a:link {
  color: #006693;
  line-height: 23px;
}

.qkb-board-action,
.qkb-board-action input,
.qkb-board-action__wrapper,
.qkb-board-action__msg-box,
.qkb-board-action__extra {
  color: #74639a;
  background: #f7f7ff;
}

.qkb-msg-bubble__typing-indicator span,
.qkb-msg-bubble__typing-indicator::before,
.qkb-msg-bubble__typing-indicator::after {
  background-color: #6f02b7;
}

.qkb-action-item--send svg {
  fill: #00b2ff;
}

.qkb-bubble-btn .qkb-bubble-btn-icon:not(.qkb-bubble-btn-icon--close) {
  fill: transparent;
}

.qkb-bubble-btn :not(.qkb-bubble-btn-icon--close) {
  background-image: url("data:image/svg+xml,%3Csvg width='50' height='36' viewBox='0 0 50 36' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M19.7976 27.0774H36.4551H36.4613C43.9262 27.0774 50 21.0036 50 13.5387C50 6.07378 43.9262 0 36.4613 0H13.5387C6.07378 0 0 6.07378 0 13.5387C0 20.2237 4.87101 25.7931 11.25 26.8839V35.625L19.7976 27.0774ZM3.72624 13.5387C3.72624 8.12942 8.12942 3.72624 13.5387 3.72624H36.4613C41.8706 3.72624 46.2738 8.12942 46.2738 13.5387C46.2738 18.948 41.8706 23.3511 36.4613 23.3511H13.5387C8.12942 23.3511 3.72624 18.948 3.72624 13.5387ZM20.4881 13.5387C20.4881 16.118 18.3972 18.2089 15.8179 18.2089C13.2386 18.2089 11.1477 16.118 11.1477 13.5387C11.1477 10.9594 13.2386 8.86847 15.8179 8.86847C18.3972 8.86847 20.4881 10.9594 20.4881 13.5387ZM33.9585 18.2089C36.5378 18.2089 38.6287 16.118 38.6287 13.5387C38.6287 10.9594 36.5378 8.86847 33.9585 8.86847C31.3792 8.86847 29.2883 10.9594 29.2883 13.5387C29.2883 16.118 31.3792 18.2089 33.9585 18.2089Z' fill='white'/%3E%3C/svg%3E");
  width: 66px;
  position: absolute;
  top: 31px;
  left: 22px;
}

.qkb-bubble-btn {
  width: 68px !important;
  height: 68px !important;
  background-color: #00b2ff !important;
  overflow: hidden;
  background-position: center;
}

.qkb-board {
  bottom: 70px !important;
}

.pointerEvents {
  pointer-events: auto;
}
</style>
